import * as Popover from "@radix-ui/react-popover";
import classNames from "classnames";
import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import iconXClose from "../../img/icons/x-close.svg";

import styles from "./FormTooltip.module.scss";

/**
 * Renders form field tooltip
 */
export const FormTooltip = (props: {
    tooltipText?: string;
    tooltipLink?: string;
    tooltipClass?: string;
}): React.ReactNode => {
    if (!props.tooltipText) {
        return null;
    }

    const tooltipTriggerClasses = classNames({
        [styles.trigger]: true,
        [`${props.tooltipClass}`]: true,
    });

    return (
        <Popover.Root modal={true}>
            <Popover.Trigger asChild>
                <button
                    aria-label={props.tooltipLink}
                    className={tooltipTriggerClasses}
                >
                    {props.tooltipLink}
                </button>
            </Popover.Trigger>
            <Popover.Portal>
                <Popover.Content
                    className={styles.container}
                    sideOffset={5}
                    style={{ zIndex: "30000" }}
                >
                    <span className={styles.content}>{props.tooltipText}</span>
                    <Popover.Close
                        className={styles.closeButton}
                        aria-label={t`Close`}
                    >
                        <SVG src={iconXClose} aria-hidden="true" />
                    </Popover.Close>
                    <Popover.Arrow />
                </Popover.Content>
            </Popover.Portal>
        </Popover.Root>
    );
};
